import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { getDepartments, getDepartment } from '../services/departmentsService';

const BASE = 'departments';

export const departmentsQueryKeys = {
  base: () => [BASE],
  detail: (id) => [BASE, 'detail', id],
  list: (data) => (data ? [BASE, 'list', data] : [BASE, 'list']),
};

export const useGetDepartment = (id, { enabled = true } = {}) => {
  return useQuery({
    queryKey: departmentsQueryKeys.detail(id),
    queryFn: () => getDepartment(id),
    enabled: enabled && !!id,
    staleTime: Infinity, // Datos de baja frecuencia de cambio
  });
};

export const useGetDepartments = (data, { enabled = true } = {}) => {
  return useQuery({
    queryKey: departmentsQueryKeys.list(data),
    placeholderData: keepPreviousData,
    queryFn: () => getDepartments(data),
    enabled: enabled,
    staleTime: Infinity, // Datos de baja frecuencia de cambio
  });
};
